export default "__VITE_ASSET__aad12a33__"